import { Types } from '@store/types';

const initialState = {};

const DesignToolCommentReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.FETCH_DESIGN_TOOL_COMMENT: {
			let tmpCommentList = [];
			if (state?.commentList?.data) {
				tmpCommentList = [...state.commentList.data];
			}
			if (action.payload.currentPage > 0) {
				tmpCommentList = [...tmpCommentList, ...action.payload.data];
			} else {
				tmpCommentList = [...action.payload.data];
			}
			action.payload.data = tmpCommentList.reverse();
			return { ...state, commentList: action.payload };
		}
		case Types.FETCH_DESIGN_TOOL_MEMBERS:
			return { ...state, memberList: action.payload };
		case Types.FETCH_PRODUCT_WISE_DOCUMENT:
			return {
				...state,
				...action.payload,
				documentResponse: action.payload.physicalSampleResponse,
				howToMeasureDocument: action.payload.howToMeasureDocResponse
			};
		default:
			return state;
	}
};

export default DesignToolCommentReducer;
